// Adaptar url en base al flag `url` del enlace
export const getButtonUrl = (button: ContentButton): string => {
  const runtimeConfig = useRuntimeConfig()
  const { locale } = useI18n()
  if (button?.url) {
    return button?.link
  } else {
    if (button?.key) {
      return `${runtimeConfig.public.BASE_URL}/${locale.value}/${button?.link}-${button.key}d.html`
    } else {
      return `${runtimeConfig.public.BASE_URL}/${button?.link}.${locale.value}.html`
    }
  }
}

export const getButtonUrlNew = (button: ContentButton): string => {
  const runtimeConfig = useRuntimeConfig()
  const { locale } = useI18n()
  return `${runtimeConfig.public.BASE_URL}/${locale.value}/${button?.link}.html`
}

// Función para verificar si un objeto está vacío
export const objIsEmpty = (obj: object | null | undefined): boolean => {
  if (obj === null || obj === undefined) {
    return true
  }
  return Object.keys(obj).length === 0;
}

interface LoggableFetchContext {
  response: { _data: unknown; status: number; statusText: string }
  request?: unknown
}

export const logError = (res: LoggableFetchContext | unknown) => {
  if (!res || typeof res !== 'object' || !('response' in res)) return
  const ctx = res as LoggableFetchContext
  const { response } = ctx
  if (!response) return
  console.log('Error', JSON.stringify({
    data: response._data,
    request: ctx.request,
    status: response.status,
    statusText: response.statusText,
  }))
}

export const generateImgUrl = (url: string): string => {
  const runtimeConfig = useRuntimeConfig()
  if (url) {
    return url.replace(runtimeConfig.public.IMG_URL, `/ipx`)
  }
  return ''
}

export const slugify = (text: string): string => {
  return text
    .toString()
    .toLowerCase()
    .normalize('NFD') // Quitar tildes
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
}